var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgAppFeature1(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.5 37.5C21.7044 37.5 20.9413 37.1839 20.3787 36.6213C19.8161 36.0587 19.5 35.2956 19.5 34.5V19.5C19.5 18.7044 19.8161 17.9413 20.3787 17.3787C20.9413 16.8161 21.7044 16.5 22.5 16.5H43.5C44.2956 16.5 45.0587 16.8161 45.6213 17.3787C46.1839 17.9413 46.5 18.7044 46.5 19.5V34.5C46.5 35.2956 46.1839 36.0587 45.6213 36.6213C45.0587 37.1839 44.2956 37.5 43.5 37.5H40.5V46.5L31.5 37.5H22.5Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5 25.5L7.5 31.5V22.5H4.5C3.70435 22.5 2.94129 22.1839 2.37868 21.6213C1.81607 21.0587 1.5 20.2956 1.5 19.5V4.5C1.5 3.70435 1.81607 2.94129 2.37868 2.37868C2.94129 1.81607 3.70435 1.5 4.5 1.5H25.5C26.2956 1.5 27.0587 1.81607 27.6213 2.37868C28.1839 2.94129 28.5 3.70435 28.5 4.5V10.5",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

export default SvgAppFeature1;